import PropTypes from "prop-types";
import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./feeds-seo-contact-details.module.css";

function FeedsSeoContactDetails({ contactDetails }) {
    const { email_address: emailAddress, phone_number: phoneNumber, address } = contactDetails.body;

    return (
        <>
            {(emailAddress || phoneNumber || address) && (
                <>
                    <h3 className={styles.contactDetailsTitle}>{contactDetails.title}</h3>
                    <div className={styles.contactDetailsBody}>
                        {address && <p>{`${gettext("general.postal_address")} ${address}`}</p>}
                        {emailAddress && (
                            <p>
                                {`${gettext("general.email_address")}\u00A0`}
                                <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                            </p>
                        )}
                        {phoneNumber && (
                            <p>
                                {`${gettext("general.phone_number")}\u00A0`}
                                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                            </p>
                        )}
                    </div>
                </>
            )}
        </>
    );
}

FeedsSeoContactDetails.propTypes = {
    contactDetails: PropTypes.shape({
        title: PropTypes.string,
        body: PropTypes.shape({
            email_address: PropTypes.string,
            phone_number: PropTypes.string,
            address: PropTypes.string,
        }),
    }),
};

export default FeedsSeoContactDetails;
